<template lang="html">
  <modal name="invitation-sent-modal" height="auto" width="416" :adaptive="true" :maxWidth="416" @before-open="beforeOpen">
    <div class="modal-container">
      <div class="modal-header bold black">
        Invitation sent!
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div>An email invitation to {{email}} has been sent. They must accept your invitation before they are added to your {{productName}} organization, {{organizationName}}, and granted {{permissionType}} permissions.</div>
        <div class="gap-3x" />
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer">
        <SymbiumButton
          kclass="btn-base"
          :isSmall="true"
          text="Close"
          :onClick="close"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton },
  methods: {
    close() {
      this.$modal.hide('invitation-sent-modal');
    },
    beforeOpen(event) {
      this.organizationName = event.params.organizationName
      this.permissionType = event.params.permissionType
      this.email = event.params.email
      this.productName = event.params.productName
    }
  },
  data() {
    return {
      organizationName: null,
      permissionType: null,
      email: null,
      productName: null,
    }
  }
}
</script>

<style lang="scss">
.thankyou-modal {
  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.18px;
  }

  .modal-body {
    height: 407px;
  }

  .modal-footer .oval-button {
    padding: 8px 16px;
    margin: 0;

    .text {
      line-height: 14px;
    }
  }
}
</style>
